<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>My first acknowledgment goes to the one true God without whom I’m not even capable of standing. A lot of love to my parents and my sibling and all of my extended family, close friends – you shaped and formed me as I am. Big gratitude to BTS, who each gave me a piece of their life’s teaching through their music. The last unforgettable vote of love and thanks is to my very ‘little people’, all of you who I do not personally know but play a significant role in changing my life- my readers, my supporters, and even my ill-wishers.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?776bd818